import { useEffect, useState } from "react";
// import underline from "../../assets/images/underline.png";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import BackSecion from "../common/header";
import { getLocalStorage } from "../../core/localStorageService";
import apiEndpoint from "../../core/apiend_point";
import { PayloadProps } from "../../core/schema";
import { triggerApi } from "../../services";
import { Spinner } from "react-bootstrap";
import ImageViewer from "react-simple-image-viewer";
import { pdfjs, Document, Page } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/legacy/build/pdf.worker.min.js",
  import.meta.url
).toString();

/**
 * Renders Component.
 * @return {StudentTimeTable} renders Component.
 */
export default function StudentTimeTable() {
  const [data, setData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [numPages, setNumPages] = useState(1);
  const [showDocument, setShowDocument] = useState(false);
  const [documentExtension, setDocumentExtension] = useState("");
  useEffect(() => {
    getTimeTable();
  }, []);

  const getTimeTable = (type = "general") => {
    setIsLoading(true);
    const user: any = JSON.parse(getLocalStorage("user") ?? "");
    let user_id = user?.student[0]?.user_id;
    const apiObject: PayloadProps = {
      payload: {
        auth_token: getLocalStorage("token"),
        user_id: user?.student[0]?.user_id,
      },
      method: "GET",
      apiUrl: `${apiEndpoint.getTimeTable}/${user_id}/${type}`,
    };

    triggerApi(apiObject)
      .then((res: any) => {
        if (res && res[0]) {
          setData(res[0].doc_full_link);
          let extension = res[0].doc_full_link.split(".").pop();
          setDocumentExtension(extension);
        } else {
          setData("");
        }
      })
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  function onDocumentLoadSuccess({ numPages }: any) {
    setNumPages(numPages);
  }

  function selectedTabData(tab: number) {
    console.log(tab);
    setSelectedTab(tab);
    if (tab === 0) {
      getTimeTable("general");
    }
    if (tab === 1) {
      getTimeTable("exam");
    }
    if (tab === 2) {
      getTimeTable("holiday");
    }
  }

  return (
    <>
      <div className="cmmn px-3">
        <Container className="container">
          <Row className="mt-4">
            <BackSecion name="Time Table" navigate_action="/home" />
          </Row>
          <Row className="mt-4 p-075 pr-075">
            <Col
              xs={4}
              className={`f-14  p-0  ${
                selectedTab === 0 ? "text_blue fw-bold" : ""
              } `}
              onClick={() => selectedTabData(0)}
            >
              <span className="fw-bolder pb-1 link_style" role="button">
                Time Table
              </span>
            </Col>
            <Col
              xs={4}
              className={`status_clr f-14 p-0 text-center ${
                selectedTab === 0 ? "text_blue fw-bold" : ""
              } `}
              onClick={() => selectedTabData(1)}
            >
              <span
                role="button"
                className="text-decoration-none status_clr link_style"
              >
                Exam time table
              </span>
            </Col>
            <Col
              xs={4}
              className={`status_clr f-14 p-0 text-end ${
                selectedTab === 0 ? "text_blue fw-bold" : ""
              } `}
              onClick={() => selectedTabData(2)}
            >
              <span
                role="button"
                className="text-decoration-none status_clr link_style"
              >
                Holidays
              </span>
            </Col>
          </Row>
          {isLoading && (
            <div className="loader">
              <Spinner animation="border" variant="primary" />
            </div>
          )}
          <Row className="mt-2">
            <div className="f-14 d-flex flex-column align-items-center status_clr">
              {" "}
              {!isLoading && data && (
                <Row className="row mx-auto mt-4">
                  {documentExtension === "pdf" ? (
                    <Document
                      loading={`Loading...`}
                      file={data}
                      onLoadSuccess={onDocumentLoadSuccess}
                    >
                      <Page
                        pageNumber={pageNumber}
                        width={300}
                        renderMode="svg"
                        object-fit="fill"
                      />
                    </Document>
                  ) : (
                    <Col
                      xs={12}
                      className="f-12 pb-3 center-content"
                      onClick={() => {
                        setShowDocument(true);
                      }}
                    >
                      <img src={data} alt="" width="300px" height="180px" />
                    </Col>
                  )}
                  {showDocument && (
                    <ImageViewer
                      src={[data]}
                      currentIndex={0}
                      disableScroll={false}
                      closeOnClickOutside={true}
                      onClose={() => {
                        // setData('');
                        setShowDocument(false);
                      }}
                      // backgroundStyle={{'background':'transparent'}}
                    />
                  )}
                </Row>
              )}
              {!isLoading && data === "" && (
                <div className="loader">No file found.</div>
              )}
            </div>
          </Row>
        </Container>
      </div>
    </>
  );
}
